import App from "../../../vendor_core/core/src/App";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import { ConfigurationTypes } from '../../../vendor_core/core/src/const/ConfigurationTypes';
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import PointerEvents from "../../../vendor_core/core/src/const/PointerEvents";
import SoundVars from "../../../vendor_core/core/src/const/SoundVars";
import ConfigManager from '../../../vendor_core/core/src/managers/ConfigManager';
import AutoplayModel from "../../../vendor_core/core/src/model/AutoplayModel";
import BetModel from "../../../vendor_core/core/src/model/BetModel";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import BaseUI from "../../../vendor_core/core/src/ui/BaseUI";
import { UIButtons } from "../../../vendor_core/core/src/ui/UIButtons";
import { UIComponents } from "../../../vendor_core/core/src/ui/UIComponents";
import { UIStates, UIModes } from "../../../vendor_core/core/src/ui/UIStates";
import { UIUpdateEvent } from "../../../vendor_core/core/src/ui/UIUpdateEvents";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import SwitchButton from "../../../vendor_core/core/src/views/components/SwitchButton";
import TextField from "../../../vendor_core/core/src/views/components/TextField";
import VendorModel from "../../../vendor_core/server/model/VendorModel";
import IVendorClientConfigRequestData from '../../../vendor_core/server/requests/contracts/IVendorClientConfigRequestData';
import { VendorCommandsEnum } from '../../../vendor_core/src/commands/VendorCommandsEnum';


export default class BBUIDesktop extends BaseUI {
    private autoSpinCounts: TextField;
    public create(): void {
        super.create();
        this.scene = ViewManager.getLayer(DefaultLayers.BetBar).setScene();
        this.scene.buttons.forEach((btn) => {
            if (btn.parent.name === "btn_buy_feature" && ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.disableBuyFeature) {
                btn.destroy();
            } else {
                this.buttons.push(btn);
                this.elements.push(btn);
            }
            
        });
        this.assignInterraction(
            Commands.TOGGLE_TURBO_SPIN,
            this.scene.buttons.get("turbo"),
            SoundVars.BUTTON_CLICK
        );

        if (GameModel.gameConfig.featureBye) {
            this.assignInterraction(
                VendorCommandsEnum.TOGGLE_BUY_FEATURE,
                this.scene.buttons.get(UIButtons.FeatureBuy),
                SoundVars.BUTTON_CLICK
            );
        }

        let turboButton = this.scene.buttons.get(
            "turbo"
        ) as SwitchButton;

        if (turboButton) {
            turboButton.on(PointerEvents.DOWN, () => {
                // console.log("turbo button on click toggle");
                turboButton.switch(GameModel.turboSpin);
            });

            App.dispatcher.on(
                GameEvents.TOGGLE_TURBO_SPIN,
                () => {
                    // console.log("Turbo off/on");
                    turboButton.switch(GameModel.turboSpin);
                },
                this
            );
        }

        this.autoSpinCounts = this.scene.sceneTextFields.get(
            "autoCount"
        ) as TextField;
        this.assignInterraction(
            Commands.SPIN,
            this.scene.buttons.get(UIButtons.Spin)
        );
        this.assignInterraction(
            Commands.STOP_AUTOPLAY,
            this.scene.buttons.get(UIButtons.StopAutoplay),
            SoundVars.BUTTON_CLICK
        );
        //    this.assignInterraction(Commands.TOGGLES_S, this.scene.buttons.get(UIButtons.StopAutoplay), SoundVars.BUTTON_CLICK);
        if (!ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.autoplayDisable) {
            this.assignInterraction(
                Commands.TOGGLE_AUTOPLAY_SETTINGS,
                this.scene.buttons.get(UIButtons.AutoPlay),
                SoundVars.BUTTON_CLICK
            );
        }
        this.assignInterraction(
            Commands.TOGGLE_SETTINGS,
            this.scene.buttons.get(UIButtons.Settings),
            SoundVars.BUTTON_CLICK
        );
        this.assignInterraction(
            Commands.TOGGLE_BET_SETTINGS,
            this.scene.buttons.get(UIButtons.Bet),
            SoundVars.BUTTON_CLICK
        );
        this.assignInterraction(
            Commands.TOGGLE_MASTER_SOUND,
            this.scene.buttons.get(UIButtons.Sound),
            SoundVars.BUTTON_CLICK
        );
        if (GameModel.canSkipSpin()) {
            this.assignInterraction(
                Commands.SKIP,
                this.scene.buttons.get(UIButtons.Stop)
            );
        }
        this.setBehaviours();
        this.setFreeSpinsMode();
        this.setPromotionBehaviours();

        if (GameModel.forceEnableRules()) {
            this.behaviourMapMaster.forEach((masterMap) => {
                masterMap.forEach((pattern, state) => {
                    if (state != UIStates.ERROR) {
                        pattern.addMask({
                            uiToDisable: [
                                this.scene.buttons.get(UIButtons.Settings),
                            ],
                        });
                    }
                });
            });
        }

        let masterSoundButton = this.scene.buttons.get(
            UIButtons.Sound
        ) as SwitchButton;

        masterSoundButton.switch(!SoundController.isSoundEnabled);

        masterSoundButton.on(PointerEvents.DOWN, () => {
            // console.log("master sound button on click toggle");
            // masterSoundButton.toggle();
            masterSoundButton.switch(!SoundController.isSoundEnabled);
        });

        App.dispatcher.on(
            GameEvents.SOUNDS_MUTED,
            () => {
                // console.log("Sound muted");
                masterSoundButton.switch(true);
            },
            this
        );

        App.dispatcher.on(
            GameEvents.SOUNDS_UNMUTED,
            () => {
                // console.log("Sound unmuted");
                masterSoundButton.switch(false);
            },
            this
        );
        // TODO think of having a config for that
    }

    public update(event: UIUpdateEvent, props?: any): void {
        if (this.scene) {
            switch (event) {
                case UIUpdateEvent.TempWin:
                    this.scene.sceneMoneyFields.get(UIComponents.Win).value =
                        SpinModel.tempWinAmount;
                    break;
                case UIUpdateEvent.Balance:
                    this.scene.sceneMoneyFields.get(
                        UIComponents.Balance
                    ).value = BetModel.balance;
                    this.autoSpinCounts.text = AutoplayModel.isAutoSpinActive()
                        ? AutoplayModel.getAutoSpinNum().toString()
                        : "";
                    break;
                case UIUpdateEvent.Bet:
                    this.scene.sceneMoneyFields.get(
                        UIComponents.TotalBet
                    ).value = BetModel.totalBet;
                    break;
                case UIUpdateEvent.ClearWin:
                    this.scene.sceneMoneyFields.get(UIComponents.Win).value = 0;
                    break;
                case UIUpdateEvent.Win:
                    this.scene.sceneMoneyFields.get(
                        UIComponents.Win
                    ).value = SpinModel.isInFreespins() ? SpinModel.freespinWinnings : SpinModel.currentWin;
                    break;
                case UIUpdateEvent.FreeGames:
                    this.scene.sceneTextFields.get(
                        UIComponents.FreeGames
                    ).text = VendorModel.freeGames
                            ? VendorModel.freeGames.spins.toString()
                            : "";
                    break;
                case UIUpdateEvent.FreeSpins:
                    this.scene.sceneTextFields.get(UIComponents.FreeSpins).text =
                        props ? props : SpinModel.freespinsNum.toString();
                    break;
                case UIUpdateEvent.Autoplay:
                    this.autoSpinCounts.text = AutoplayModel.isAutoSpinActive()
                        ? AutoplayModel.getAutoSpinNum().toString()
                        : "";
                    break;
                case UIUpdateEvent.ClearFreeSpins:
                    this.scene.sceneTextFields.get(
                        UIComponents.FreeSpins
                    ).text = "0";
                    break;
                case UIUpdateEvent.All:
                    this.scene.sceneMoneyFields.get(
                        UIComponents.Balance
                    ).value = BetModel.balance;
                    this.scene.sceneMoneyFields.get(
                        UIComponents.TotalBet
                    ).value = BetModel.totalBet;
                    this.scene.sceneMoneyFields.get(
                        UIComponents.Win
                    ).value = SpinModel.getAccumulatedWin();
                    this.scene.sceneTextFields.get(
                        UIComponents.FreeGames
                    ).text = VendorModel.freeGames
                            ? VendorModel.freeGames.spins.toString()
                            : "";
                    this.autoSpinCounts.text = AutoplayModel.isAutoSpinActive()
                        ? AutoplayModel.getAutoSpinNum().toString()
                        : "";
                    break;
            }
        }
    }

    protected setBehaviours() {
        this.setBehaviour(UIStates.IDLE, {
            uiToEnable: ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.autoplayDisable ?
                [
                    GameModel.gameConfig.featureBye ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
                    this.scene.buttons.get(UIButtons.Sound),
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Settings),
                    this.scene.buttons.get(UIButtons.Bet),
                    this.scene.buttons.get("turbo")
                ] : [
                    GameModel.gameConfig.featureBye ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
                    this.scene.buttons.get(UIButtons.Sound),
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.AutoPlay),
                    this.scene.buttons.get(UIButtons.Settings),
                    this.scene.buttons.get(UIButtons.Bet),
                    this.scene.buttons.get("turbo")
                ],
            uiToDisable: ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.autoplayDisable ?
                [
                    //   this.scene.buttons.get(UIButtons.AutoPlay),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                ] : [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                ],
            uiToShow: [
                this.scene,
                GameModel.gameConfig.featureBye ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
                this.scene.buttons.get(UIButtons.Sound),
                this.scene.buttons.get(UIButtons.Spin),
                ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.autoplayDisable ? null : this.scene.buttons.get(UIButtons.AutoPlay),
                this.scene.buttons.get(UIButtons.Settings),
                this.scene.buttons.get(UIButtons.Bet),
                this.scene.groups.get(UIComponents.BetInfoGroup),
                this.scene.buttons.get("turbo")
            ],
            uiToHide: ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.autoplayDisable ?
                [
                    this.autoSpinCounts,
                    this.scene.buttons.get(UIButtons.AutoPlay),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                    this.scene.groups.get(UIComponents.FreeSpinsInfoGroup),
                    this.scene.groups.get(UIComponents.FreeGamesInfoGroup),
                    GameModel.gameConfig.featureBye ? null : this.scene.buttons.get(UIButtons.FeatureBuy),
                ] : [
                    this.autoSpinCounts,
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                    this.scene.groups.get(UIComponents.FreeSpinsInfoGroup),
                    this.scene.groups.get(UIComponents.FreeGamesInfoGroup),
                    GameModel.gameConfig.featureBye ? null : this.scene.buttons.get(UIButtons.FeatureBuy),
                ],
        });
        this.setBehaviour(UIStates.SPIN, {
            uiToDisable: this.buttons,
        });
        this.setBehaviour(UIStates.SPIN_RESULT, {
            uiToHide: [this.scene.buttons.get(UIButtons.Spin)],
            uiToEnable: GameModel.canSkipSpin() ? [
                this.scene.buttons.get(UIButtons.Stop),
                this.scene.buttons.get(UIButtons.Sound),
                this.scene.buttons.get("turbo")
            ] : [
                this.scene.buttons.get(UIButtons.Sound),
                this.scene.buttons.get("turbo")
            ],
            uiToShow: [this.scene.buttons.get(UIButtons.Stop)],
        });

        this.setBehaviour(UIStates.SPIN_END, {
            uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
        });

        this.setBehaviour(UIStates.STOP_SPIN, {
            uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
        });

        // this.setBehaviour(UIStates.WIN, {
        //     uiToShow: [this.win]
        // });

        this.setBehaviour(UIStates.FREE_SPINS, {
            uiToHide: [
                this.scene.buttons.get(UIButtons.Spin),
                this.scene.buttons.get(UIButtons.Stop),
                this.scene.buttons.get(UIButtons.StopAutoplay),
                this.scene.groups.get(UIComponents.BetInfoGroup)

            ],
            uiToShow: [
                this.scene.groups.get(UIComponents.FreeSpinsInfoGroup),
            ],
        });

        this.setBehaviour(UIStates.AUTO, {
            uiToEnable: [this.scene.buttons.get(UIButtons.StopAutoplay)],
            uiToShow: [
                this.autoSpinCounts,
                this.scene.buttons.get(UIButtons.StopAutoplay),
            ],
            uiToHide: [
                this.scene.buttons.get(UIButtons.Spin),
                this.scene.buttons.get(UIButtons.Stop),
            ],
            uiToDisable: [
                this.scene.buttons.get(UIButtons.Settings),
                this.scene.buttons.get(UIButtons.AutoPlay),
                this.scene.buttons.get(UIButtons.Bet),
                GameModel.gameConfig.featureBye ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
            ],
        });

        this.setBehaviour(UIStates.HIDDEN, {
            uiToHide: [this.scene],
        });
        // this.setPromotionBehaviours();
    }

    protected setPromotionBehaviours() {
        this.setBehaviour(
            UIStates.IDLE,
            {
                uiToEnable: [
                    this.scene.buttons.get(UIButtons.Spin),
                    // this.scene.buttons.get("stop_freegames")
                ],
                uiToDisable: [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.Bet),
                    this.scene.buttons.get("stop_freegames"),// TEMP
                ],
                uiToShow: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Settings),
                    this.scene.groups.get(UIComponents.FreeGamesInfoGroup),
                ],
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.Bet),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                    this.scene.buttons.get("stop_freegames"),// TEMP
                    this.autoSpinCounts,
                    this.scene.groups.get(UIComponents.BetInfoGroup),
                    this.scene.groups.get(UIComponents.FreeSpinsInfoGroup),
                    this.scene.buttons.get(UIButtons.AutoPlay),
                    GameModel.gameConfig.featureBye ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
                ],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.SPIN,
            {
                uiToDisable: this.buttons,
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.SPIN_RESULT,
            {
                uiToHide: [this.scene.buttons.get(UIButtons.Spin)],
                uiToEnable: [this.scene.buttons.get(UIButtons.Stop)],
                uiToShow: [this.scene.buttons.get(UIButtons.Stop)],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.SPIN_END,
            {
                uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.STOP_SPIN,
            {
                uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.FREE_SPINS,
            {
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                ],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.HIDDEN,
            {
                uiToHide: [this.scene],
            },
            UIModes.PROMOTION_SPINS
        );
    }

    protected setFreeSpinsMode() {
        let bonusBts = [...this.buttons];
        bonusBts.splice(bonusBts.indexOf(this.scene.buttons.get(UIButtons.Settings)), 1);
        bonusBts.splice(bonusBts.indexOf(this.scene.buttons.get(UIButtons.Sound)), 1);
        this.setBehaviour(UIStates.IDLE, {
            uiToHide: [...bonusBts, this.autoSpinCounts],
        }, UIModes.FREE_SPINS);
        this.setBehaviour(UIStates.FREE_SPINS, {
            uiToHide: [
                this.scene.groups.get(UIComponents.BetInfoGroup),
                this.scene.groups.get(UIComponents.FreeGamesInfoGroup),
                GameModel.gameConfig.featureBye ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
            ],
            uiToDisable: [
                this.scene.buttons.get(UIButtons.Spin),
                this.scene.buttons.get(UIButtons.Stop),
                this.scene.buttons.get(UIButtons.StopAutoplay),
            ],
            uiToShow: [
                this.scene.groups.get(UIComponents.FreeSpinsInfoGroup)
            ]
        }, UIModes.FREE_SPINS);
        this.setBehaviour(UIStates.SPIN, {
            uiToDisable: [this.scene.buttons.get(UIButtons.Settings)],
            uiToHide: [...bonusBts, this.autoSpinCounts]
        }, UIModes.FREE_SPINS);
        this.setBehaviour(UIStates.SPIN_RESULT, {
            uiToHide: [...bonusBts, this.autoSpinCounts]
        }, UIModes.FREE_SPINS);
        this.setBehaviour(UIStates.SPIN_END, {
            uiToEnable: [this.scene.buttons.get(UIButtons.Settings)],
            uiToHide: [...bonusBts, this.autoSpinCounts]
        }, UIModes.FREE_SPINS);
    }
}
